(function () {
	const params = new URLSearchParams(window.location.search);
	const currentUTM = params.get('utm_source');
	let source = localStorage.getItem('utm_source');

	// If a new utm_source is present, update it
	if (currentUTM) {
		localStorage.setItem('utm_source', currentUTM);
		source = currentUTM;
	}
	// Otherwise, keep the existing one
	else if (!source) {
		source = null;
	}

	let phoneNumber;
	switch (source) {
		case 'google':
			phoneNumber = '1-833-421-2768';
			break;
		case 'reddit':
			phoneNumber = '1-833-421-2766';
			break;
		case 'cwf':
			phoneNumber = '1-833-421-2769';
			break;
		case 'direct':
			phoneNumber = '1-833-622-7404';
			break;
		case 'lawyer':
			phoneNumber = '1-833-622-6241';
			break;
		default:
			phoneNumber = '1-833-421-2763'; // fallback
	}

	// Replace all placeholders with data-phone-placeholder attribute
	document.querySelectorAll('[data-phone-placeholder]').forEach((el) => {
		const link = document.createElement('a');
		link.href = `tel:${phoneNumber.replace(/[^0-9+]/g, '')}`;
		link.textContent = phoneNumber;
		link.className = el.className + ' utm-phone-link'; // added custom class
		el.innerHTML = '';
		el.appendChild(link);
	});
})();
